import {debounce} from "./debounce";

const scrollObserver = (
        {
            items,
            rootMargin = "-250px 0px",
            threshold = 0.02,
            targetClass = "animated",
        },
        callback = false
    ) => {

    if (!items || items.length === 0) return;

    let options = {
        root: null,
        rootMargin,
        threshold,
    };

    let observer = new IntersectionObserver(beTouching, options);
    items.forEach(item => observer.observe(item));

    // Handle Items Intersecting
    function beTouching(entries, ob) {
        entries.forEach((entry) => {
            if (callback) {
                callback(entry)
                return
            }
            if (entry.isIntersecting) {
                entry.target.classList.add(targetClass);
                if (!entry.target.classList.contains('both-direction')) ob.unobserve(entry.target);
            } else {
                entry.target.classList.remove(targetClass);
            }
        });
    }

    /**
     * Parallax
     * @type {string}
     */
    let parallaxItems = document.querySelectorAll('.parallax');
    if (parallaxItems?.length) {
        const handleParallaxScroll = () => {
            parallaxItems?.forEach((item) => {
                const parallaxValue = item.dataset.parallax ?? 14
                const direction = item.dataset.direction === 'down' ? -1 : 1
                let dataParallax = item.getBoundingClientRect().top / parallaxValue * direction + 'px';
                const child = Array.from(item.children).find(el => el.tagName.toLowerCase() === 'img' || el.tagName.toLowerCase() === 'video');
                child.style.transform = 'translate3d(0, ' + dataParallax + ', 0)';
            });
        }
        handleParallaxScroll();
        const onScroll = debounce(() => handleParallaxScroll(), 6);
        window.addEventListener("scroll", onScroll);
    }
}

export default scrollObserver;
